<template lang="pug">
    .video
        video(
            ref="player"
            class="video-js vjs-city-offer"
            controls
            playsinline
        )
            source(
                :src="src"
                :type="mime"
            )
</template>

<script>
import videojs from 'video.js'
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';

import { mapGetters } from 'vuex'
import { find, has, get } from 'lodash'

export default {
    name: "VideoPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {}
            }
        },
        video: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            player: null
        }
    },
    watch: {
        src(fresh, old) {
            if (old && fresh !== old && this.player) {
                this.player.pause()
                this.player.src([
                    {
                        type: this.mime,
                        src: this.src
                    }
                ])
                // this.initialize()
                this.player.load()
                this.player.play()
            }
        }
    },
    computed: {
        isHls() {
            return !! get(this.video, 'hls')
        },
        mime() {
            if(this.isHls) {
                return this.video.hls.mime
            } else {
                return this.video.source.mime
            }
        },
        src() {
            if (this.video) {
                let cdnEndpoint = process.env.VUE_APP_CDN_ENDPOINT
                if (process.env.VUE_APP_CDN_ROOT) cdnEndpoint += process.env.VUE_APP_CDN_ROOT

                if (this.isHls) {
                    return cdnEndpoint + this.video.hls.path + '/' + this.video.hls.name
                } else {
                    return cdnEndpoint + this.video.source.path + '/' + this.video.source.name
                }
            }
            // this.activeProductMedia.video.hls
        },
    },
    methods: {
        initialize() {
            const options = {
                muted: true,
                language: 'en',
                preload: 'auto',
                fluid: true,
                aspectRatio: '9:16',
                autoplay: true,
                // inactivityTimeout: 1,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216,
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true,
                },
                controlBar: {
                    pictureInPictureToggle: false,
                },
                // plugins: {
                //     hlsQualitySelector: {
                //         displayCurrentQuality: true,
                //     }
                // }
            };
            this.player = videojs(this.$refs.player, options);
            this.player.httpSourceSelector();

            // this.player.controls(false)

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
                this.$emit('ended');
            })
        }
    },
    mounted() {
        this.initialize()
    },
    beforeDestroy() {
        if (this.player) this.player.dispose()
    }
}
</script>
<style lang="sass" nolang="scss">
    @import "~bulma/sass/utilities/mixins";
    @import '~video.js/dist/video-js.css';
    @import '~@/assets/sass/variables';

    $border-radius: 0 !default

    @keyframes rotate
      to
        transform: rotate(360deg)

    .video-js.vjs-city-offer
        border-radius: $border-radius
        .vjs-big-play-button
            width: 2em
            height: 2em
            line-height: 1.9em
            border-radius: 1em
            left: calc(50% - 1em)
            top: calc(50% - 1em)
            backdrop-filter: blur(4px)
            background-color: rgba(255,255,255,.6)
            border: 2px solid $primary
            color: $primary

        &:hover, &:focus
            .vjs-big-play-button
                backdrop-filter: blur(4px)
                background-color: rgba(200,200,200,.6)
                border: 2px solid $primary
                color: $primary


        .vjs-loading-spinner
            border: 3px solid rgba(0,0,0, 0.6)
            width: 45px
            height: 45px
            &:before, &:after
                margin: -3px
                animation: rotate .8s linear infinite
                border-top-color: $primary
            &:after
                display: none
                border-top-color: $primary-invert


        button:focus, .vjs-menu-item:focus
            outline: none
            color: $primary

        .vjs-control-bar
            height: 5em
            padding-top: 2em
            background: linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,0) 100%)
            border-bottom-left-radius: $border-radius
            border-bottom-right-radius: $border-radius

        button.vjs-icon-cog
            font-size: 1.3em

        .vjs-menu-button-popup .vjs-menu .vjs-menu-content
            background-color: rgba(0,0,0,.6)
            border-radius: $border-radius
            backdrop-filter: blur(4px)

        video
            border-radius: $border-radius
            &:focus
                outline: none

        .vjs-slider
            background-color: rgba(255, 255, 255, 0.3)
            border-radius: 10px

        .vjs-progress-holder
            .vjs-load-progress
                background-color: $primary
                transition: width .15s linear
            .vjs-play-progress,
            .vjs-load-progress,
            .vjs-load-progress > div
                border-radius: 10px

        .vjs-menu li.vjs-menu-item:focus,
        .vjs-menu li.vjs-menu-item:hover,
        .js-focus-visible .vjs-menu li.vjs-menu-item:hover
            &:not(.vjs-selected)
                background-color: rgba(255, 255, 255, 0.3)

    // ---

    .video-js.vjs-city-offer
        background: transparent
        .vjs-control-bar
            opacity: 0
        &:hover
            .vjs-control-bar
                opacity: 1
        .vjs-big-play-button
            display: none
</style>
